<template lang="pug">
section
  .slideshow
    .container.is-fluid.slideshow-title
      .columns.is-centered
        .column.is-narrow
          h1.title.is-1.has-text-white FanFair Original Films
      .columns.is-centered
        .column.is-narrow
          b-button(type="is-danger", tag="a", href="https://www.youtube.com/user/TheShowstopper76", target="_blank")
            span Watch Now 
            font-awesome-icon(:icon="['fab', 'youtube']")
        .column.is-narrow
          b-button(type="is-white", tag="router-link", to="/video") Learn More
    .images
  br
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";

library.add(faYoutube);

export default {
  name: "Films"
};
</script>

<style lang="scss" scoped>
.slideshow {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;

  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
}

.images {
  background: url("../assets/slideshow.png");
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 300%;

  animation: slideshow 120s linear infinite;
  -webkit-animation: slideshow 120s linear infinite;
  -moz-animation: slideshow 120s linear infinite;

  animation-fill-mode: forwards;

  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
}

@keyframes slideshow {
  0% {
    left: 0;
  }
  100% {
    left: -200%;
  }
}

.slideshow-title {
  position: absolute;
  width: 100%;
  top: 40%;
  text-align: center;
  z-index: 5;
}
</style>
